import React from 'react';
import ProjectContent from '../components/ProjectContent';

const WebsiteBlock = () => <ProjectContent projectName='Website Blocker'/>;

export default WebsiteBlock;